// German translations for mobile app
export const de = {
  // Common
  welcome: "Willkommen",
  next: "Weiter",
  back: "Zurück",
  submit: "Absenden",
  cancel: "Abbrechen",
  loading: "Wird geladen...",
  error: "Fehler",
  success: "Erfolgreich",
  and: "und",

  // Auth
  login: "Anmelden",
  register: "Registrieren",
  email: "E-Mail",
  password: "Passwort",
  firstName: "Vorname",
  lastName: "Nachname",
  forgotPassword: "Passwort vergessen?",

  // Validation Messages
  fieldRequired: "Dieses Feld ist erforderlich",
  emailRequired: "E-Mail-Adresse ist erforderlich",
  passwordRequired: "Passwort ist erforderlich",
  invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
  passwordTooShort: "Passwort muss mindestens 6 Zeichen lang sein",

  // Login & Auth UI
  welcomeBack: "Willkommen zurück",
  signInToContinue: "Anmelden, um fortzufahren",
  rememberMe: "Mich erinnern",
  loginWith: "Anmelden mit",
  dontHaveAccount: "Sie haben noch kein Konto?",
  orContinueWith: "oder fortfahren mit",
  enterEmail: "Geben Sie Ihre E-Mail-Adresse ein",
  enterPassword: "Geben Sie Ihr Passwort ein",

  // Register UI
  createAccount: "Konto erstellen",
  signUpToGetStarted: "Registrieren Sie sich, um loszulegen",
  joiningCompany: "Firma beitreten",
  fullName: "Vollständiger Name",
  enterName: "Geben Sie Ihren vollständigen Namen ein",
  confirmPassword: "Passwort bestätigen",
  reEnterPassword: "Geben Sie Ihr Passwort erneut ein",
  iAgreeToThe: "Ich stimme zu",
  termsOfService: "Nutzungsbedingungen",
  privacyPolicy: "Datenschutzrichtlinie",
  alreadyHaveAccount: "Haben Sie bereits ein Konto?",
  nameMinLength: "Name muss mindestens 2 Zeichen lang sein",
  passwordsDoNotMatch: "Passwörter stimmen nicht überein",
  mustAgreeToTerms: "Sie müssen den Nutzungsbedingungen und der Datenschutzrichtlinie zustimmen",
  signIn: "Anmelden",

  // Liveness Check
  moveFaceIntoFrame: "Bringen Sie Ihr Gesicht in den Rahmen",
  livenessSmile: "Bitte lächeln Sie breit",
  livenessBlink: "Bitte zwinkern Sie mit den Augen",
  livenessTurnLeft: "Drehen Sie Ihren Kopf nach links",
  livenessTurnRight: "Drehen Sie Ihren Kopf nach rechts",
  multipleFacesDetected: "Nur eine Person erlaubt",
  captureError: "Bild konnte nicht aufgenommen werden",
  verifying: "Wird verifiziert...",
  smile: "Lächeln",
  turnLeft: "Nach links drehen",
  turnRight: "Nach rechts drehen",
  blink: "Zwinkern",

  // API & Errors
  unknownError: "Ein unbekannter Fehler ist aufgetreten.",
  apiConnectionError: "API-Verbindungsfehler",
  unknown3DLivenessError: "Unbekannter 3D-Lebendigkeitstest-Fehler",
  livenessVerificationFailed: "Lebendigkeitstest fehlgeschlagen. Bitte versuchen Sie es erneut.",
  networkError: "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.",
  nA: "N/A",
  unknown: "Unbekannt",

  // Super Admin Panel
  totalUsers: "Gesamtbenutzer",
  companies: "Unternehmen",
  submissions: "Einreichungen",
  pendingReview: "Ausstehende Überprüfung",
  userManagement: "Benutzerverwaltung",
  allSubmissions: "Alle Einreichungen",
  systemHealth: "Systemgesundheit",
  alerts: "Warnungen",
  systemSettings: "Systemeinstellungen",
  languageSettings: "Spracheinstellungen",
  analytics: "Analytik",
  securityLogs: "Sicherheit & Protokolle",
  superAdminPanel: "Super-Admin-Panel",
  manageYourPlatform: "Verwalten Sie Ihre gesamte Plattform",
  loadingDashboard: "Dashboard wird geladen...",
  navigationError: "Navigation zu diesem Bildschirm nicht möglich.",
  retry: "Wiederholen",
};
